import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import * as rxsync from '@ivlasov/rxsync';
import * as _ from 'lodash';
import { EfoEgiService } from './egi.service';
import * as moment from 'moment';
import { eachLimit } from 'async-es';
import { switchMap, map, tap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { AccessService } from '../../core/services/access.service';
import { DealerService } from '../../msop/dealer.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ElevationService } from './elevation.service';

@Injectable({
  providedIn: 'root',
})
export class EfoFacebookService {
  private myAdAccounts$: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly myAdAccounts: Observable<any> =
    this.myAdAccounts$.asObservable();
  private myAdAccountIds: any[];

  private business_id = '1519891034929973';
  private auth_key = '629ea048ef635147a565f76a116ed3cc';

  private company = {
    name: 'EGI',
    account_status: 1,
    account_id: '308302767',
    id: 'act_308302767',
  };
  private company_name = 'edifice';

  public facebookDatesPresets = {
    'Last 30 Days': {
      date_preset: 'last_30d',
      time_ranges: _.map(_.range(-30, 0), function (i) {
        return {
          since: moment().add(i, 'days').format('YYYY-MM-DD'),
          until: moment().add(i, 'days').format('YYYY-MM-DD'),
        };
      }),
    },
    'This Month': {
      date_preset: 'this_month',
      time_ranges: _.map(_.range(0, +moment().format('D')), function (i) {
        return {
          since: moment().startOf('month').add(i, 'days').format('YYYY-MM-DD'),
          until: moment().startOf('month').add(i, 'days').format('YYYY-MM-DD'),
        };
      }),
    },
    'Last Month': {
      date_preset: 'last_month',
      time_ranges: _.map(
        _.range(0, moment().add(-1, 'month').daysInMonth()),
        function (i) {
          return {
            since: moment()
              .add(-1, 'month')
              .startOf('month')
              .add(i, 'days')
              .format('YYYY-MM-DD'),
            until: moment()
              .add(-1, 'month')
              .startOf('month')
              .add(i, 'days')
              .format('YYYY-MM-DD'),
          };
        },
      ),
    },
    'This Year': {
      date_preset: 'this_year',
      time_ranges: _.map(_.range(0, moment().month() + 1), function (i) {
        //time_ranges: _.map(_.range(0, 12), function (i) {
        return {
          since: moment()
            .startOf('year')
            .add(i, 'months')
            .startOf('month')
            .format('YYYY-MM-DD'),
          until: moment()
            .startOf('year')
            .add(i, 'months')
            .endOf('month')
            .format('YYYY-MM-DD'),
        };
      }),
    },
  };

  private radiusTarget: any = {
    name: '527 ATLANTA RD, CUMMING, GA,United States',
    address_string: '527 ATLANTA RD, CUMMING, GA,United States',
    distance_unit: 'mile',
    latitude: 34.1944249,
    longitude: -84.1361423,
    radius: 15,
    country: 'US',
  };

  private facebookCmds = {
    page: {
      //ie account
      efo_endpoint: '/facebook/postFbData',
      cmd: '/me/accounts',
      data: {
        name: 'Andean Chevrolet#2',
        category: '625688294262999',
        about:
          'Family-owned and operated since 1948, Andean Chevrolet provides our customers with a wide selection of vehicles.',
        picture:
          'https://media-dmg.assets-cdk.com/teams/repository/export/v/1/005/457a8a6641005884e0050568ba825/005457a8a6641005884e0050568ba825.png',
        cover_photo: {
          url: 'https://media-dmg.assets-cdk.com/teams/repository/export/v/1/005/457a8a6641005884e0050568ba825/005457a8a6641005884e0050568ba825.png',
        },
        single_line_address: '17 Bay Lane, 14225',
        location: {
          address: '',
          zip: '',
          city: 'Cumming',
          state: 'GA',
          country: 'US',
        },
        address: '17 Bay Lane, Cheektowaga, NY 14225',
        phone: '800-555-1212',
        category_list: ['625688294262999', '149998721725634'],
      },
    },
    adaccount: {
      //ie account
      efo_endpoint: '/facebook/postFbData',
      cmd: '/1519891034929973/adaccounts',
      data: {
        name: 'Andean Chevrolet',
        currency: 'USD',
        timezone_id: 7,
        end_advertiser: '1519891034929973',
        media_agency: 'NONE',
        partner: 'NONE',
      },
    },
    campaign: {
      efo_endpoint: '/facebook/postFbData',
      cmd: '/act_830635667303173/campaigns',
      data: {
        name: 'MikeTest Campaign#1',
        objective: 'LINK_CLICKS',
        //bid_strategy: "LOWEST_COST_WITH_BID_CAP",
        //buying_type: "AUCTION",
        status: 'PAUSED',
        special_ad_category: 'NONE',
      },
    },
    adset: {
      efo_endpoint: '/facebook/postFbData',
      cmd: '/act_830635667303173/adsets',
      data: {
        campaign_id: 120330000078418906,
        name: ' Test AdSet#1',
        start_time: moment().add(1, 'month').startOf('month').unix(),
        end_time: moment().add(1, 'month').endOf('month').unix(),
        bid_amount: 100,
        daily_budget: 1000,
        billing_event: 'IMPRESSIONS', //needed to use IMPRESSIONS in sandbox, usually would be LINK_CLICKS
        optimization_goal: 'REACH', //needed to use REACH in sandbox, usually would be LINK_CLICKS
        targeting: {
          age_max: 65,
          age_min: 18,
          geo_locations: {
            custom_locations: [this.radiusTarget],
            //location_types: ['home', 'recent'],
          },
          brand_safety_content_filter_levels: [
            'FACEBOOK_STANDARD',
            'AN_STANDARD',
          ],
        },
      },
    },
    adimage: {
      //use link
      efo_endpoint: '/facebook/createFbimage',
      cmd: '/act_830635667303173/adimages',
      data: {
        filename:
          'https://inventory-dmg.assets-cdk.com/5/1/6/23165345615x640.jpg',
      },
    },
    adcreative: {
      efo_endpoint: '/facebook/postFbData',
      cmd: '/act_830635667303173/adcreatives',
      data: {
        actor_id: '100563884991570',
        body: '{{vehicle.title}}',
        object_story_spec: {
          page_id: '100563884991570',
          instagram_actor_id: '3467217786641279',
          template_data: {
            link: 'https://www.edificegroup.com/',
            message: '{{vehicle.title}}',
            name: '{{vehicle.title}}',
            description: '{{vehicle.price strip_zeros}} ',
            multi_share_end_card: false,
            format_option: 'carousel_images_multi_items',
          },
        },
        name: '{{vehicle.title}} 2020-05-04-074aa981854a1dac11b753aa27b4e07f',
        status: 'ACTIVE',
        title: '{{vehicle.title}}',
        product_set_id: '1660800787395709',
      },
      data_single: {
        name: 'Test Adcreative #1',
        object_story_spec: {
          link_data: {
            image_hash: 'fbdbc23e953cb4253a9718afef99cbcf',
            link: 'https://scontent.fatl1-2.fna.fbcdn.net/v/t45.1600-4/96216491_120330000078420906_2681600347796930560_n.jpg?_nc_cat=107&_nc_sid=2aac32&_nc_oc=AQm7gweIQ_Wi2LpTMo2ZPdu4YCUhJOoJoFLK_SAQO7tqwIVSsTmSgGXHGP2kz-0Bekw&_nc_ht=scontent.fatl1-2.fna&oh=983b440ea6f06f0b8589bb7dc7fe74ce&oe=5ED66A5F',
            message: 'try it out',
          },
          page_id: '101795954866268',
        },
      },
    },
    ad: {
      efo_endpoint: '/facebook/postFbData',
      cmd: '/act_830635667303173/ads',
      data: {
        name: 'Mike Ad Test #2',
        status: 'PAUSED',
        creative: { creative_id: '120330000078438906' },
        adset_id: '120330000078419306',
      },
    },
    catalog: {
      efo_endpoint: '/facebook/postFbData',
      cmd: '/1519891034929973/owned_product_catalogs',
      data: {
        name: 'catalogName',
        vertical: 'vehicles',
        da_display_settings: {
          carousel_ad: {
            transformation_type: 'background_cropping_and_padding',
          },
          single_ad: {
            transformation_type: 'background_cropping_and_padding',
          },
        },
      },
    },
    product_feeds: {
      efo_endpoint: '/facebook/postFbData',
      cmd: '/catalog_id/product_feeds',
      data: {
        name: 'productFeedName',
        schedule: {
          hour: +moment().add(1, 'minutes').format('H'),
          interval: 'DAILY',
          interval_count: 1,
          minute: +moment().add(1, 'minutes').format('m'),
          timezone: 'America/New_York',
          url:
            'https://egi-api.epiphanex.com/facebook/vehicleCatalogCsv?account_num=' +
            'R84276313' +
            '&dco_site_id=1&auth_key=629ea048ef635147a565f76a116ed3cc',
        },
      },
    },
  };
  public fbCmdResponse = {
    page: { id: '' },
    adaccount: { id: '' },
    campaign: { id: '' },
    adset: { id: '' },
    adcreative: { id: '' },
    ad: { id: '' },
    catalog: { id: '' },
    produce_feed: { id: '' },
  };

  //public myAdAccountIds:any[] = [];
  private userSubscription$;
  private user: any = {};
  private eflowBaseUrl = environment.nestEflowApiUrl;

  constructor(
    private efoEgi: EfoEgiService,
    private accessApi: AccessService,
    public dealerService: DealerService,
    private elevationService: ElevationService,
    private http: HttpClient,
  ) {
    this.userSubscription$ = this.accessApi.mee.subscribe((user) => {
      this.user = user;
      this.getMyAdAccountIds(user).subscribe();
    });
  }

  getMyAdAccountIds(user): Observable<any> {
    return this.http
      .post(
        `${environment.nestElevationApiUrl}/elevate/getMyAdAccountIds`,
        _.pick(user, ['user_uuid', 'groups', 'user_info']),
      )
      .pipe(
        tap((rs) => {
          rs = _.map(rs, 'adaccount_id');
          this.myAdAccountIds = rs;
          this.myAdAccounts$.next(rs);
          return rs;
        }),
      );
  }

  get(cmd, fields, limit): Observable<any> {
    return this.efoEgi.getData('/facebook/getFbData', {
      cmd: cmd,
      fields: fields,
      limit: limit,
    });
    return this.http.post(
      `${environment.nestElevationApiUrl}/facebook/getFbData`,
      {
        cmd,
        fields,
        limit,
      },
    );
  }
  post(cmd, data): Observable<any> {
    return this.efoEgi.postData('/facebook/postFbData', {
      cmd,
      data,
    });
  }
  delete(fb_object_id): Observable<any> {
    return this.efoEgi.postData('/facebook/deleteFbData', { id: fb_object_id });
    //return this.efoEgi.deleteData('/facebook/deleteFbData',{cmd:cmd,data:{}});
  }

  getCmds(adaccount_id): Observable<any> {
    return this.efoEgi.getData('/facebook/getFbCmds', {
      adaccount_id: 'act_' + adaccount_id,
    });
  }

  getCmdData(cmd: string, qParams: any): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/facebook/getFbData`,
      { cmd, ...qParams },
    );
    // return this.efoEgi.getData(
    //   '/facebook/getFbData',
    //   _.extend({}, { cmd: cmd }, qParams),
    // );
  }

  setBusinessId(business_id): void {
    this.business_id = business_id;
  }
  getBusinessId(): Observable<any> {
    return of(this.business_id);
  }
  getBusiness(business_id): Observable<any> {
    return this.getCmdData('/' + business_id, {
      fields:
        'id,name,vertical,system_users,business_users,vertical_id,instagram_accounts',
      limit: 100,
    }).pipe(
      map((rs) => {
        return rs;
      }),
    );
  }

  getAdaccounts(): Observable<any> {
    return this.getCmdData('/me/adaccounts', {
      fields:
        'fields=id,account_id,account_status,currency,end_advertiser,end_advertiser_name,media_agency,partner,name,timezone_id,timezone_name',
    }).pipe(
      map((rs) => {
        _.each(rs.data, (d) => {
          d.id = d.account_id;
          d.label = d.name + ' - ' + d.account_id;
        });
        rs.data = _.sortBy(rs.data, 'name');
        return rs;
      }),
    );
  }
  getOwnedProductCatalogs(): Observable<any> {
    return this.getCmdData('/' + this.business_id + '/owned_product_catalogs', {
      fields:
        'id,name,feed_count,product_count,product_sets,diagnostics,product_feeds{id,latest_upload,schedule}',
    }).pipe(
      map((rs) => {
        _.each(rs.data, (d) => {
          d.label = d.name + ' - ' + d.id;
        });
        rs.data = _.sortBy(rs.data, 'name');
        return rs;
      }),
    );
  }

  getAdaccountsEgi(): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adaccounts', {}).pipe(
      map((rs) => {
        return _.sortBy(rs, 'name');
      }),
    );
  }

  getCatalogsEgi(): Observable<any> {
    return this.getCatalogs({});
  }
  getClientsEgi(): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/clients', {}).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.label = d.name + ' - ' + d.id;
        });
        return _.sortBy(rs, 'name');
      }),
    );
  }
  getClientPagesEgi(): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/client_pages', {}).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.label = d.name + ' - ' + d.id;
        });
        return _.sortBy(rs, 'name');
      }),
    );
  }

  getCampaignsEgi(): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/campaigns', {
      limit: 2000,
    }).pipe(
      map((rs: any[]) => {
        //return only current and future campaigns
        return _.filter(
          _.reject(_.flatten(_.compact(rs)), { account_id: '308302767' }),
          (d) => {
            return d.stop_time >= moment().format('YYYY-MM-DD');
          },
        );
      }),
    );
  }

  getAdsetsEgi(): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adsets', {
      limit: 2000,
    }).pipe(
      map((rs) => {
        //return only current and future campaigns
        return rs;
        //return _.filter(_.reject(_.flatten(_.compact(rs)),{account_id: '308302767'}),(d)=>{return d.stop_time >= moment().format('YYYY-MM-DD');});
      }),
    );
  }

  getPixelsEgi(): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adspixels', {
      limit: 2000,
    });
  }
  getGrowPodiumCampaigns(): Observable<any> {
    return this.getAccountCampaigns('224549872166483');
  }
  getAccountCampaigns(adaccount_id): Observable<any> {
    return this.getCmdData('/act_' + adaccount_id + '/campaigns', {
      fields:
        'name,id,start_time,stop_time,insights{impressions,clicks,spend},ads{name,preview_shareable_link,previews.ad_format(DESKTOP_FEED_STANDARD)}',
    }).pipe(
      map((rs) => {
        let fbAcctCampaigns = _.filter(rs.data, function (d) {
          return _.has(d, 'ads');
        });
        _.each(fbAcctCampaigns, function (c) {
          c.iframe_urls = _.flatten(
            _.map(c.ads.data, function (ad) {
              return _.map(ad.previews.data, 'body');
            }),
          );
          c.preview_shareable_links = _.map(
            c.ads.data,
            'preview_shareable_link',
          );
        });
        //We are reusing ad_account ids for filter further
        const campaignDealer = fbAcctCampaigns[0].name.split(' - ')[0];
        fbAcctCampaigns = _.filter(fbAcctCampaigns, (d) => {
          return d.name.indexOf(campaignDealer) == 0;
        });
        return fbAcctCampaigns;
      }),
    );
  }

  searchEdificeAds(search_str, options): Observable<any> {
    return this.getEdificeFbData(
      '/facebook/edifice/ads',
      _.extend(
        { limit: 1000000 },
        _.pick(options, ['filters', 'search_str', 'limit']),
      ),
    ).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.iframe_url = _.has(d, 'previews.data')
            ? _.first(_.map(d.previews.data, 'body'))
            : null;
          d.iframe_url_src = !_.isNull(d.iframe_url)
            ? d.iframe_url.match(/src=\"([^\"]*)\"/)[1].replace('&amp;', '&')
            : null;
        });
        return rs;
      }),
    );
  }

  getAds(options, allData = false): Observable<any> {
    return this.getEdificeFbData(
      '/facebook/edifice/ads',
      _.extend(
        { limit: 1000000 },
        _.pick(options, ['filters', 'search_str', 'limit']),
      ),
      allData,
    ).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.iframe_url = _.has(d, 'previews.data')
            ? _.first(_.map(d.previews.data, 'body'))
            : null;
          d.iframe_url_src = !_.isNull(d.iframe_url)
            ? d.iframe_url.match(/src=\"([^\"]*)\"/)[1].replace('&amp;', '&')
            : null;
        });
        return rs;
      }),
    );
  }

  getEdificeAds(adaccount_id, options?): Observable<any> {
    return this.getAds(
      _.extend({ filters: { account_id: adaccount_id } }, options),
    ).pipe();
  }

  getCreatives(options?): Observable<any> {
    return this.getEdificeFbData(
      '/facebook/edifice/adcreatives',
      _.extend(
        { limit: 1000000 },
        _.pick(options, ['filters', 'search_str', 'limit']),
      ),
    );
  }

  getEdificeCreatives(adaccount_id, options?): Observable<any> {
    return this.getCreatives(
      _.extend({ filters: { account_id: adaccount_id } }, options),
    ).pipe();
  }
  searchImages(search_str): Observable<any> {
    //return the adImages by search term like nissan sales
    //search on ad,
    // then get associated creatives to get image hash values
    // then retrieve images
    return rxsync
      .waterfall([
        () => {
          return this.searchEdificeAds(search_str, {}).pipe(
            map((rs) => {
              return _.map(rs, 'creative.id');
            }),
          );
        },
        (creative_ids) => {
          return this.getAdCreatives({
            filters: { id: creative_ids.join(',') },
          }).pipe(
            map((rs) => {
              return _.flatten(
                _.map(rs, 'object_story_spec.link_data.child_attachments'),
              );
            }),
          );
        },
        (creative_images) => {
          var image_hashes = _.map(creative_images, 'image_hash');
          return this.getAdImages({
            filters: { hash: image_hashes.join(',') },
          }).pipe(
            map((rs) => {
              return rs;
            }),
          );
        },
      ])
      .pipe();
  }
  filterImages(manufacturers, campaign_types): Observable<any> {
    return this.getAdImagesAll().pipe(
      map((rs) => {
        rs = _.reject(rs, (d) => {
          return !_.has(d, 'name');
        });

        if (!_.isEmpty(manufacturers)) {
          rs = _.uniqBy(
            _.flatten(
              _.map(manufacturers, (d) => {
                return _.filter(rs, (i) => {
                  return i.name && i.name.toLowerCase().indexOf(d) > -1;
                });
              }),
            ),
            'id',
          );
        }
        if (!_.isEmpty(campaign_types)) {
          rs = _.uniqBy(
            _.flatten(
              _.map(campaign_types, (d) => {
                return _.filter(rs, (i) => {
                  return i.name && i.name.toLowerCase().indexOf(d) > -1;
                });
              }),
            ),
            'id',
          );
        }
        rs = _.reverse(_.sortBy(rs, 'created_time'));
        return rs;
      }),
    );
  }
  filterAds(manufacturers, campaign_types): Observable<any> {
    return this.getAds({}).pipe(
      map((rs) => {
        rs = _.reject(rs, (d) => {
          return !_.has(d, 'name');
        });

        if (!_.isEmpty(manufacturers)) {
          rs = _.uniqBy(
            _.flatten(
              _.map(manufacturers, (d) => {
                return _.filter(rs, (i) => {
                  return i.name && i.name.toLowerCase().indexOf(d) > -1;
                });
              }),
            ),
            'id',
          );
        }
        if (!_.isEmpty(campaign_types)) {
          rs = _.uniqBy(
            _.flatten(
              _.map(campaign_types, (d) => {
                return _.filter(rs, (i) => {
                  return i.name && i.name.toLowerCase().indexOf(d) > -1;
                });
              }),
            ),
            'id',
          );
        }
        rs = _.reverse(_.sortBy(rs, 'created_time'));
        return rs;
      }),
    );
  }

  getAdsByAccountAndDate(account_num, date) {
    return this.elevationService.getData('/facebook/getAdsByAccountAndDate', {
      account_num,
      date: date,
    });
  }

  getAdsByBrand(brand, type, account_num?) {
    return this.elevationService.getData(
      '/facebook/getAdsByBrand',
      {
        brand: brand,
        type: type,
        account_num: account_num,
      },
      {
        headers: this.accessApi.apiHeader,
      },
    );
  }

  getAdPreview(ad_id): Observable<any> {
    return this.get(
      '/' + ad_id,
      'preview_shareable_link,previews.ad_format(DESKTOP_FEED_STANDARD),name',
      100,
    ).pipe(
      map((d) => {
        d.iframe_url = _.has(d, 'previews.data')
          ? _.first(_.map(d.previews.data, 'body'))
          : null;
        d.iframe_url_src = !_.isNull(d.iframe_url)
          ? d.iframe_url.match(/src=\"([^\"]*)\"/)[1].replace('&amp;', '&')
          : null;
        return d;
      }),
    );
  }
  data = {
    campaigns: [],
    adsets: [],
    creatives: [],
    ads: [],
    images: [],
    catalogs: [],
    pixels: [],
    clients: [],
    pages: [],
    audiences: [],
    offline_events: [],
  };
  preloadFacebookData(): Observable<any> {
    //return the adImages by search term like nissan sales
    //search on ad,
    // then get associated creatives to get image hash values
    // then retrieve images
    return forkJoin([
      this.getImages({ limit: 1000000 }),
      this.getCreatives({ limit: 100000 }),
      this.getAds({ limit: 100000 }),
      this.getCampaigns({ limit: 100000 }),
      this.getCatalogs({ limit: 100000 }),
      this.getPixels({ limit: 100000 }),
      this.getAudiences({ limit: 100000 }),
      this.getClients({ limit: 100000 }),
      this.getPages({ limit: 100000 }),
    ]).pipe(
      tap(([rs1, rs2, rs3, rs4, rs5, rs6, rs7, rs8, rs9, rs10]) => {
        this.data.images = rs1;
        this.data.creatives = rs2;
        this.data.ads = rs3;
        this.data.campaigns = rs4;
        this.data.catalogs = rs5;
        this.data.pixels = rs6;
        this.data.audiences = rs7;
        this.data.clients = rs8;
        this.data.pages = rs9;
      }),
    );
  }
  searchEdificeImages(search_str, options): Observable<any> {
    return this.getEdificeFbData(
      '/facebook/edifice/adimages',
      _.extend(
        { search_str: search_str },
        _.pick(options, ['search_str', 'limit']),
      ),
    );
  }
  getAdCreatives(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adcreatives', options);
  }
  //Campaigns
  getCampaigns(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/campaigns', options);
  }
  //Adsets
  getSets(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adsets', options);
  }
  //Catalog
  getCatalogs(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/catalogs', options).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.label = d.name + ' - ' + d.id;
          d.last_uploaded =
            _.has(d, 'product_feeds.data') &&
            _.has(d, 'product_feeds.data[0].latest_upload.end_time')
              ? moment(d.product_feeds.data[0].latest_upload.end_time).fromNow()
              : 'never';
        });
        return _.sortBy(rs, 'name');
      }),
    );
  }
  //Pixels
  getPixels(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adspixels', options);
  }
  //AdAccounts
  getAccounts(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adaccounts', options);
  }
  //Pages
  getPages(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/client_pages', options);
  }
  //Clients
  getClients(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/clients', options);
  }
  //Audiences
  getAudiences(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/custom_audiences', options);
  }
  //Images
  getImages(options): Observable<any> {
    return this.getEdificeFbData('/facebook/edifice/adimages', options);
  }

  getEdificeFbData(url, options, allData = false): Observable<any> {
    if (_.isNull(this.user) || _.isUndefined(this.myAdAccountIds)) {
      return of([]).pipe();
    } else {
      var params =
        this.myAdAccountIds.length > 0 && !allData
          ? { filters: { account_id: this.myAdAccountIds.join(',') } }
          : {};
      return this.http
        .post(
          `${environment.nestElevationApiUrl}${url}`,
          _.extend(_.pick(options, ['filters', 'search_str', 'limit']), params),
        )
        .pipe(
          map((rs) => {
            if (Array.isArray(rs)) {
              return _.map(rs, 'data');
            }

            // If `rs` isn't an array, handle appropriately
            throw new Error('Unexpected response format. Expected an array.');
          }),
        );
    }
  }

  getAdImages(options): Observable<any> {
    return this.getImages(options);
  }

  getAdImagesAll(reload_flag?: boolean): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.data.images) && !reload_flag) {
      return of(this.data.images).pipe();
    } else {
      return this.getImages({ limit: 1000000 }).pipe(
        map((rs) => {
          this.data.images = rs;
          return rs;
        }),
      );
    }
  }
  //Creatives
  getAccountAdCreatives(adaccount_id): Observable<any> {
    return this.getCmdData('/act_' + adaccount_id + '/adcreatives', {
      fields:
        'id,name,body,preview_shareable_link,previews.ad_format(DESKTOP_FEED_STANDARD)',
      limit: 100,
    }).pipe(
      map((rs) => {
        return rs.data;
      }),
    );
  }
  getAccountAdImages(adaccount_id): Observable<any> {
    return this.getCmdData('/act_' + adaccount_id + '/adimages', {
      fields:
        'hash,permalink_url,status,id,creatives,name,is_associated_creatives_in_adgroups,updated_time,url,url_128,created_time,original_height,original_width,height,width',
      limit: 100,
    }).pipe(
      map((rs) => {
        return rs.data;
      }),
    );
  }

  //Insights
  getAdAccountInsights(adaccount_id, data): Observable<any> {
    return this.getCmdData(
      '/act_' + adaccount_id + '/insights',
      _.omitBy(data, _.isNull),
    ).pipe(
      map((rs) => {
        return rs.data;
      }),
    );
  }

  //Create MarketPlace Ad
  createSampleCatalogAd(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/elevate/setupAllDealerFbCatalogAd', {
      dealer_uuid,
    });
  }

  setupNewAllDealerFbCatalog(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/facebook/setupNewAllDealerFbCatalog', {
      dealer_uuid,
    });
  }
  setupCatalogProductSetsGeneral(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/facebook/setupCatalogProductSetsGeneral', {
      dealer_uuid,
    });
  }

  setupAllDealerFbMarketPlaceAd(dealer_uuid, options): Observable<any> {
    options = _.pick(options, ['use_growpodium', 'status']);
    return this.efoEgi.getData(
      '/facebook/setupAllDealerFbMarketPlaceAd',
      _.extend(
        { dealer_uuid, use_growpodium: true, status: 'PAUSED' },
        options,
      ),
    );
  }

  // Reach information
  getInterestGroups(interest): Observable<any> {
    //interest - ie, manufacturer, manufacture model
    return this.getCmdData('/search', {
      type: 'adinterest',
      q: interest,
      limit: 1000,
    }).pipe(
      map((rs) => {
        return _.filter(rs.data, { topic: 'Hobbies and activities' });
      }),
    );
  }
  getReachEstimateByZips(adaccount_id, zips): Observable<any> {
    let targeting_spec = {
      geo_locations: {
        zips: _.map(zips, (d) => {
          return { key: 'US:' + d };
        }),
      },
      age_min: 20,
      age_max: 65,
    };
    var cmd = '/act_' + adaccount_id + '/reachestimate';
    return this.getCmdData(cmd, { targeting_spec: targeting_spec }).pipe(
      map((rs) => {
        return rs.data[0];
        //this.reachCounts.selected_zips = rs.data[0].users_upper_bound - ((Math.floor(_.sum(_.map(this.efoMap.selectedZips,function(d){return +d.split('').reverse().join('')}))/this.efoMap.selectedZips.length)/100000)*1000);
      }),
    );
  }

  getReachByCompetitor(
    adaccount_id,
    competitor,
    zips,
    unselected_zips,
    callback,
  ): void {
    // let selectedZips = this.efoMap.selectedZips;
    // let unselectedZips = _.difference(_.map(this.efoMap.ypZipDataWithDistance,'zip'),selectedZips);
    let selectedZips = zips;
    let unselectedZips = unselected_zips;
    let fbReachEstimates = [
      {
        key: 'intenders_competitors',
        name: 'potential intended buyers - competitors',
        description:
          'Potential competitor visitors.  Facebook audience that was close to my competitors recently.',
        count: 0,
        targeting_spec: {
          geo_locations: {
            custom_locations: [
              {
                name: competitor.name + ' Shoppers',
                distance_unit: 'kilometer',
                latitude: competitor.latitude,
                longitude: competitor.longitude,
                radius: 1,
                country: 'US',
              },
            ],
            //location_types: ['recent'],
          },
          age_min: 20,
          age_max: 65,
        },
      },
      {
        key: 'intenders_competitors_my_area',
        name: 'potential intended buyers - from my area.',
        description:
          'Facebook audience that was close to my competitors recently.',
        count: 0,
        targeting_spec: {
          excluded_geo_locations: {
            zips: _.map(
              _.take(_.without(unselectedZips, '14302'), 2000),
              (d) => {
                return { key: 'US:' + d };
              },
            ),
            //location_types: ['home'],
          },
          geo_locations: {
            custom_locations: [
              {
                name: competitor.name + ' Shoppers',
                distance_unit: 'kilometer',
                latitude: competitor.latitude,
                longitude: competitor.longitude,
                radius: 1,
                country: 'US',
              },
            ],
            //location_types: ['recent'],
          },
          age_min: 20,
          age_max: 65,
        },
      },
    ];
    let reachResults = [];
    if (true) {
      //not sure if this works yet?
      rxsync
        .eachLimit(
          _.map(fbReachEstimates, (reach) => {
            var cmd = '/act_' + adaccount_id + '/reachestimate';
            return this.getCmdData(cmd, {
              targeting_spec: reach.targeting_spec,
            }).pipe(
              map((rs) => {
                return {
                  key: reach.key,
                  name: reach.name,
                  count: rs.data[0].users_upper_bound,
                };
              }),
            );
          }),
          1,
        )
        .subscribe((arr) => {
          reachResults = _.flatten(arr);
          callback(null, reachResults);
        });
    } else {
      eachLimit(
        fbReachEstimates,
        1,
        (reach, cb) => {
          var cmd = '/act_' + adaccount_id + '/reachestimate';
          this.getCmdData(cmd, {
            targeting_spec: reach.targeting_spec,
          }).subscribe((rs) => {
            reachResults.push({
              key: reach.key,
              name: reach.name,
              count: rs.data[0].users_upper_bound,
            });
            cb();
          });
        },
        () => {
          callback(reachResults);
        },
      );
    }
  }

  public fbReachEstimates = {
    radius: {
      name: 'radius',
      count: 0,
      targeting_spec: {
        geo_locations: { countries: ['US'] },
        age_min: 20,
        age_max: 65,
      },
    },
    zip_codes: {
      name: 'zip_codes',
      count: 0,
      targeting_spec: {
        geo_locations: { zips: [{ key: 'US:30040' }] },
        age_min: 20,
        age_max: 65,
      },
    },
    special1: {
      name: 'special1',
      count: 0,
      targeting_spec: {
        age_max: 65,
        age_min: 18,
        geo_locations: {
          custom_locations: [
            {
              name: '630 SCENIC HWY, LAWRENCEVILLE, GA United States',
              address_string: '630 SCENIC HWY, LAWRENCEVILLE, GA United States',
              distance_unit: 'mile',
              latitude: 33.9265403,
              longitude: -83.9962421,
              radius: 14.58,
              primary_city_id: 2433097,
              region_id: 3853,
              country: 'US',
            },
          ],
          //location_types: ['home', 'recent'],
        },
      },
    },
    special2: {
      name: 'special2',
      count: 0,
      targeting_spec: {
        age_max: 65,
        age_min: 18,
        excluded_geo_locations: {
          custom_locations: [
            {
              distance_unit: 'mile',
              latitude: 34.452218,
              longitude: -83.71582,
              radius: 3,
              primary_city_id: 2430972,
              region_id: 3853,
              country: 'US',
            },
          ],
          //location_types: ['home'],
        },
        flexible_spec: [
          {
            interests: [
              {
                id: '6002933181659',
                name: 'Mazda MX-5',
              },
              {
                id: '6003031026255',
                name: 'Mazda',
              },
              {
                id: '6003543041027',
                name: 'Mazda3',
              },
            ],
          },
        ],
        geo_locations: {
          custom_locations: [
            {
              distance_unit: 'mile',
              latitude: 34.252676,
              longitude: -83.743286,
              radius: 10,
              primary_city_id: 2430845,
              region_id: 3853,
              country: 'US',
            },
            {
              distance_unit: 'mile',
              latitude: 34.329828,
              longitude: -83.702087,
              radius: 1,
              primary_city_id: 2432248,
              region_id: 3853,
              country: 'US',
            },
            {
              name: '1392 HWY 400 SOUTH, DAWSONVILLE, GA United States',
              address_string:
                '1392 HWY 400 SOUTH, DAWSONVILLE, GA United States',
              distance_unit: 'mile',
              latitude: 34.3471448,
              longitude: -84.0513688,
              radius: 11.78,
              primary_city_id: 2431739,
              region_id: 3853,
              country: 'US',
            },
          ],
          //location_types: ['recent'],
        },
        brand_safety_content_filter_levels: [
          'FACEBOOK_STANDARD',
          'AN_STANDARD',
        ],
      },
    },
  };

  getReachEstimates(adaccount_id, callback): void {
    eachLimit(
      _.take(_.values(this.fbReachEstimates), 5),
      1,
      (reach, cb) => {
        let cmd = '/act_' + adaccount_id + '/reachestimate';

        this.getCmdData(cmd, {
          targeting_spec: reach.targeting_spec,
        }).subscribe((rs) => {
          this.fbReachEstimates[reach.name].count =
            rs.data[0].users_upper_bound;
          cb();
        });
      },
      () => {
        callback(this.fbReachEstimates);
      },
    );
  }
  fbBrandInterestGroups = [];
  getReachNumbers(adaccount_id, zips, interest_groups, callback): void {
    let selectedZips = zips;
    let fbReachEstimates = [
      {
        key: 'selected_zips',
        name: 'selected zips',
        description: 'Facebook Reach based on selected zip codes.',
        count: 0,
        targeting_spec: {
          geo_locations: {
            zips: _.map(selectedZips, (d) => {
              return { key: 'US:' + d };
            }),
          },
          age_min: 20,
          age_max: 65,
        },
      },
      {
        key: 'brand_interest_my_area',
        name: 'brand enthusiasts in my area',
        description: 'People who showed an interest in my car brand.',
        count: 0,
        targeting_spec: {
          geo_locations: {
            zips: _.map(selectedZips, (d) => {
              return { key: 'US:' + d };
            }),
          },
          flexible_spec: [
            {
              interests: _.map(interest_groups, (d) => {
                return _.pick(d, ['id', 'name']);
              }),
            },
          ],
          age_min: 20,
          age_max: 65,
        },
      },
    ];

    let reachResults = [];
    eachLimit(
      _.take(fbReachEstimates, 20),
      1,
      (reach, cb) => {
        var cmd = '/act_' + adaccount_id + '/reachestimate';

        this.getCmdData(cmd, {
          targeting_spec: reach.targeting_spec,
        }).subscribe((rs) => {
          reachResults.push({
            key: reach.key,
            name: reach.name,
            count: rs.data[0].users_upper_bound,
          });
          cb();
        });
      },
      () => {
        callback(reachResults);
      },
    );
  }

  refreshCatalogData(catalog_id): Observable<any> {
    return this.efoEgi.getData('/facebook/requestProductFeedUpdate', {
      catalog_id,
    });
  }

  loadAll2Db(): Observable<any> {
    return this.efoEgi.getData('/facebook/loadAll2Db', {
      auth_key: this.auth_key,
    });
  }
  loadTable2Db(tbl): Observable<any> {
    return this.efoEgi.getData('/facebook/load' + tbl + '2Db', {
      auth_key: this.auth_key,
    });
  }
  loadTable2DbByAccount(tbl, account_id): Observable<any> {
    return this.efoEgi.getData('/facebook/load' + tbl + '2Db', {
      account_id,
      auth_key: this.auth_key,
    });
  }
  loadTable2DbById(tbl, id): Observable<any> {
    return of({ msg: 'not implemented yet' });
    //return this.efoEgi.getData('/facebook/load'+tbl+'2Db',{id:id,auth_key:'629ea048ef635147a565f76a116ed3cc'})
  }
  loadEgiImages2Db(): Observable<any> {
    return this.loadTable2DbByAccount('Adimages', '308302767');
  }
  loadEgiAds2Db(): Observable<any> {
    return this.loadTable2DbByAccount('Ads', '308302767');
  }
  uploadLinkCheckerData(link_file_name, dealers, link_lines): Observable<any> {
    return this.efoEgi.postData('/facebook/uploadLinkCheckerData', {
      filename: link_file_name,
      data: {
        dealers,
        link_lines,
      },
    });
  }
  duplicateCampaign(adaccount_id, campaign_id, deep_copy?): Observable<any> {
    deep_copy = _.isUndefined(deep_copy) ? false : true;
    return this.efoEgi.postData('/facebook/duplicateFbCampaign', {
      adaccount_id,
      campaign_id,
      deep_copy,
    });
  }
  duplicateAdset(
    adaccount_id,
    adset_id,
    campaign_id,
    deep_copy?,
  ): Observable<any> {
    deep_copy = _.isUndefined(deep_copy) ? false : true;
    return this.efoEgi.postData('/facebook/duplicateFbAdset', {
      adaccount_id,
      adset_id,
      campaign_id,
      deep_copy,
    });
  }

  getAdsets(): Observable<any> {
    return this.getCmdData('/me/adaccounts', {
      fields:
        'id,account_id,account_status,currency,end_advertiser,end_advertiser_name,media_agency,partner,name,timezone_id,timezone_name,campaigns{bid_strategy,lifetime_budget,name,daily_budget,status,spend_cap,adlabels,objective,created_time,start_time,stop_time,account_id,buying_type}',
      limit: 50,
    }).pipe(
      map((rs) => {
        return _.filter(
          _.reject(_.flatten(_.compact(_.map(rs.data, 'campaigns.data'))), {
            account_id: '308302767',
          }),
          (d) => {
            return d.stop_time >= moment().format('YYYY-MM-DD');
          },
        );
      }),
    );
  }
  getUploadStatus(): Observable<any> {
    return this.efoEgi.getData('/facebook/getFbUploadStatus', {});
  }
  getOffLineSummary(): Observable<any> {
    return this.efoEgi.getData('/facebook/getFbOffLineSummary', {}).pipe(
      map((rs) => {
        _.each(rs, function (d) {
          d.last_date = _.isNumber(d.event_time_max)
            ? moment.unix(d.event_time_max).format('YYYY-MM-DD')
            : 'no upload';
        });
        return rs;
      }),
    );
  }
  getUploadMatchesSummary(): Observable<any> {
    return this.efoEgi.getData('/facebook/getFbUploadMatchesSummary', {});
  }
  targetList2CustomAudience(account_num): Observable<any> {
    return this.http.get(
      `${this.eflowBaseUrl}/facebook/targetList2CustomSalesServiceAudience?account_num=${account_num}`,
    );
  }
  crissCrossGeo2CustomAudience(account_num): Observable<any> {
    return this.efoEgi.getData('/facebook/crissCrossGeo2CustomAudience', {
      account_num,
    });
  }
  getCrissCrossTargets(account_num, deal_month: String): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/facebook/getCrissCrossTargets`,
      {
        account_num,
        months: [deal_month],
        distance: 15,
        limit: 1000,
      },
    );
  }
  getCrissCrossMatchPreviewReport(
    account_num: String,
    months: String[],
  ): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/facebook/getCrissCrossMatchPreviewReport`,
      {
        account_num,
        months,
        distance: 15,
        limit: 200,
      },
    );
  }
  //Note - this is pointing to elevate
  setupAllDealerFbCampaignGood(dealer_uuid, adaccount_id): Observable<any> {
    return this.efoEgi.getData('/elevate/setupAllDealerFbCampaignGood', {
      dealer_uuid,
      adaccount_id,
    });
  }

  getAdvGeoAudienceEstimates(options): Observable<any> {
    return this.efoEgi.getData('/facebook/getAdvGeoAudienceEstimates', options);
  }
  setupAdvGeoAudienceAdset(options): Observable<any> {
    return this.efoEgi.getData('/facebook/setupAdvGeoAudienceAdset', options);
  }
  getAdvCrissCrossAudienceEstimate(options): Observable<any> {
    return this.efoEgi.getData('/facebook/getAdvCrissCrossEstimate', options);
  }
  setupAdvCrissCrossAdset(options): Observable<any> {
    return this.efoEgi.getData('/facebook/setupAdvCrissCrossAdset', options);
  }
  getDealerGeoEstimate(options): Observable<any> {
    return this.efoEgi.getData('/facebook/getDealerGeoEstimate', options);
  }

  getActiveFacebookCampaignData(options?): Observable<any> {
    return this.efoEgi.getData('/facebook/getActiveFacebookCampaignData', {
      ...options,
    });
  }

  getDataByAdaccount(adaccount_id): Observable<any> {
    return this.efoEgi.getData('/facebook/getByAdaccount', {
      account_id: adaccount_id,
    });
  }
  refreshDataByAdaccount(adaccount_id): Observable<any> {
    return this.efoEgi.getData('/facebook/loadByAdaccount', {
      account_id: adaccount_id,
    });
  }
  getByAdaccountLocal(adaccount_id): Observable<any> {
    return this.efoEgi.getData('/facebook/getByAdaccountLocal', {
      adaccount_id,
    });
  }
  getByAdaccountLive(adaccount_id): Observable<any> {
    return this.efoEgi.getData('/facebook/getByAdaccountLive', {
      adaccount_id,
    });
  }

  //
  getAllFacebookAdData(options?: any): Observable<any> {
    //or report_uuid: "5a3cad86-ab9a-459b-9a86-68260bf95753"
    return this.efoEgi.getData(
      '/facebook/getAllFacebookAdData',
      _.extend({}, options),
    );
  }
  getActiveFacebookAdData(options?: any): Observable<any> {
    //or report_uuid: "5a3cad86-ab9a-459b-9a86-68260bf95753"
    return this.efoEgi.getData(
      '/facebook/getActiveFacebookAdData',
      _.extend({}, options),
    );
  }

  getAllFacebookData(options?: any): Observable<any> {
    //or report_uuid: "5a3cad86-ab9a-459b-9a86-68260bf95753"
    //by adaccount_id,account_num,or dealer_uuid, adaccount_ids, account_nums,dealer_uuids
    return this.efoEgi.getData(
      '/facebook/getAllFacebookData',
      _.extend({}, options),
    );
  }
  getAllDealersAdaccounts(options?: any): Observable<any> {
    //or report_uuid: "5a3cad86-ab9a-459b-9a86-68260bf95753"
    //by adaccount_id,account_num,or dealer_uuid, adaccount_ids, account_nums,dealer_uuids
    return this.efoEgi.getData(
      '/facebook/getAllDealersAdaccounts',
      _.extend({}, options),
    );
  }
  getAllFacebookDataByAdaccountId(adaccount_id): Observable<any> {
    return this.efoEgi.getData('/facebook/getAllFacebookData', {
      adaccount_id,
    });
  }
  getAllFacebookDataByAccountNum(account_num): Observable<any> {
    return this.efoEgi.getData('/facebook/getAllFacebookData', {
      account_num,
    });
  }
  getAllFacebookDataByDealerUuid(dealer_uuid): Observable<any> {
    return this.efoEgi.getData('/facebook/getAllFacebookData', {
      dealer_uuid,
    });
  }
}
